import React from "react";
import { Filter, SlidersHorizontal } from "lucide-react";
import DateInputwithcal from "@/components/ui/DateInputwithcal";
import {
    reportBtnPrimary,
    reportBtnSecondary,
    reportCard,
    reportCardPadding,
    reportHeading,
    reportInput,
    reportLabel,
    reportSectionTitle,
} from "./reportTheme";

export const ReportFilterField = ({ label, children, className = "" }) => (
    <div className={`flex flex-col gap-1 min-w-[140px] flex-1 sm:flex-initial ${className}`}>
        <span className={reportLabel}>{label}</span>
        {children}
    </div>
);

export const ReportDateInput = ({ label, name, value, onChange }) => (
    <ReportFilterField label={label}>
        <DateInputwithcal name={name} value={value} onChange={onChange} />
    </ReportFilterField>
);

export const ReportSelectInput = ({ label, value, onChange, options = [] }) => (
    <ReportFilterField label={label}>
        <div className="relative">
            <Filter className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400 pointer-events-none" />
            <select value={value} onChange={onChange} className={`${reportInput} pl-9`}>
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    </ReportFilterField>
);

export const ReportNumberInput = ({ label, value, onChange, placeholder, min = 0 }) => (
    <ReportFilterField label={label}>
        <input
            type="number"
            min={min}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={reportInput}
        />
    </ReportFilterField>
);

const ReportFilterPanel = ({ onSubmit, onReset, children, columns = "" }) => (
    <div className={`${reportCard} overflow-hidden`}>
        <div className={reportSectionTitle}>
            <SlidersHorizontal className="h-4 w-4 text-blue-600 dark:text-blue-400" />
            <span className={`text-sm font-semibold ${reportHeading}`}>Report filters</span>
        </div>
        <div className={reportCardPadding}>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit?.();
                }}
            >
                <div className={`grid gap-4 ${columns || "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"}`}>
                    {children}
                </div>
                <div className="mt-5 flex flex-wrap gap-2 border-t border-gray-100 dark:border-gray-800 pt-4">
                    <button type="submit" className={reportBtnPrimary}>
                        Apply filters
                    </button>
                    {onReset && (
                        <button type="button" onClick={onReset} className={reportBtnSecondary}>
                            Reset
                        </button>
                    )}
                </div>
            </form>
        </div>
    </div>
);

export default ReportFilterPanel;
